// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"424767e5","407":"5dac18a5","479":"daa177c7","509":"c58d8b25","578":"932cc684","668":"f2d60af4","669":"4a7a49fc","853":"e94b19ab","960":"2cde8fc6"}[chunkId] + ".chunk.js";
};